module.exports = "pegasus/assets/themelp1/product/108.png";